module.exports = global["surveylab_page_likertHorizontalFree"] = require("-!/app/node_modules/ts-loader/index.js??ref--4!./likert-horizontal-free.ts");